// extracted by mini-css-extract-plugin
export default {"section":"func_section__UA90Q","title":"func_title__3e+Gj","wrapper":"func_wrapper__atVtZ"};